import { getTokens } from "./authStore";

const AUTH_SERVER = import.meta.env.VITE_APP_AUTH_SERVER_URI;

/**
 * Trigger the "Passwort vergessen" mail for an account. REST call to the
 * auth-server's admin endpoint (`POST /reset-password/:userUuid`), which runs
 * the same workflow as the public form. 409 means the organization signs in
 * via SSO and has no local password to reset.
 */
export async function sendPasswordResetLink(userUuid: string): Promise<void> {
  const res = await fetch(`${AUTH_SERVER}/reset-password/${userUuid}`, {
    method: "POST",
    headers: { authorization: `Bearer ${getTokens()?.access_token ?? ""}` },
  });
  if (res.status === 409) {
    throw new Error(
      "Nicht verfügbar: die Organisation meldet sich per SSO an, es gibt kein lokales Passwort.",
    );
  }
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}
